import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { createBrowserRouter, Route, RouterProvider, Routes } from "react-router-dom";
import Footer from "./component/Footer";
import Header from "./component/Header";
import Hero from "./component/Hero";
import Adver from "./component/pages/Adver";
import Contact from "./component/pages/Contact";
import Home from './component/pages/Home';

const router=createBrowserRouter([
  {
    path:'/',
    element:<>
    <Home/>
    </>
  },
  {
    path:'/advertise',
    element:<>
    <Adver/>
    </>
  },
  {
    path:'/contact',
    element:<>
    <Contact/>
    
    </>
  },
  
])

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}>
    <App/>
    </RouterProvider>
    
    
  </React.StrictMode>
);





